import cross from '~/assets/icons/cross.svg';
import {
	Button,
	ButtonBorderRadius,
	ButtonColors,
	ButtonHeight,
} from '~/components/ui/Button';
import { Divider } from '~/components/ui/Divider';
import { Text } from '~/components/ui/Text';
import { rage } from '~/rage';
import { StyledTopContainer } from './Head.styled';

const Head = () => {
	return (
		<div>
			<StyledTopContainer>
				<Text>Регистрация транспорта</Text>
				<Button
					color={ButtonColors.Default}
					height={ButtonHeight.Height20}
					borderRadius={ButtonBorderRadius.Radius5}
					style={{ maxWidth: 20 }}
					onClick={() => rage.vehicleRegistration.exitMenu()}
				>
					<img src={cross} width={10} height={10} />
				</Button>
			</StyledTopContainer>
			<Divider
				$direction={'H'}
				style={{ marginTop: 20, marginBottom: 30 }}
				$color={'rgba(255,255,255,0.1)'}
			/>
		</div>
	);
};

export { Head };
